import { cleanStatus } from '@/helpers/text'

export const isValidEmail = (email) => {
  if (email) {
    return email.match(
      /^([\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+\.)*[\w\!\#$\%\&\'\*\+\-\/\=\?\^\`{\|\}\~]+@((((([a-z0-9]{1}[a-z0-9\-]{0,62}[a-z0-9]{1})|[a-z])\.)+[a-z]{2,6})|(\d{1,3}\.){3}\d{1,3}(\:\d{1,5})?)$/i
    )
  } else {
    return false
  }
}

export const isValidPassword = (password) => {
  if (password) {
    return password.match(
      /^(?=.*[A-Z])(?=.*[\W])(?=.*[0-9])(?=.*[a-z]).{8,128}$/gm
    )
  } else {
    return false
  }
}

const returnTips = (content) => {
  return Object.keys(content).reduce((acc, key) => {
    acc.push(`${content[key]}`)

    return acc
  }, [])
}

export const tooltipContentForStateCell = (errors, suggestedEdits) => {
  let tipsErrors = []
  let tipsSuggestedEdits = []

  if (errors && Object.keys(errors).length) {
    tipsErrors = returnTips(errors)
  }
  if (suggestedEdits && Object.keys(suggestedEdits).length) {
    tipsSuggestedEdits = returnTips(suggestedEdits)
  }
  
  return [...tipsErrors, ...tipsSuggestedEdits]
}

export const tooltipContentPerEachField = (errors, suggestedEdits, field) => {
  let tips = []
  if (errors && Object.keys(errors).includes(field)) {
    return `${errors[field]}`
  }
  if (suggestedEdits && Object.keys(suggestedEdits).includes(field)) {
    return `${suggestedEdits[field]}`
  }
  
  return ''
}

export const setToLocalStorageByUserId = (data, key, userId) => {
  const savedValues = JSON.parse(localStorage.getItem(key)) || {}
  const updatedValues = JSON.stringify({ ...savedValues, [userId]: data })
  localStorage.setItem(key, updatedValues)
}
